import request from '@/http/http'
const PREFIX = 'api/feature-management';
export function getFeatures(query) {
    return request({
        url: PREFIX + "/features" ,
        params:query,
    })
}
export function updateFeatures(data) {
    return request({
        url: PREFIX + "/features" ,
        method: 'put',
        data
    })
}